import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";

import rootReducer from "./rootReducer";

const preloadedState = window.___REDUX_INITIAL_STATE___
  ? window.___REDUX_INITIAL_STATE___ : {};

const middleware = process.env.NODE_ENV !== "production" ?[logger]:[];
console.log('NODE_ENV',process.env.NODE_ENV)
const configureEnvStore = configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV !== "production",
});

export default configureEnvStore;
